<template>
  <div :class="[{ [$style.deleteIndent]: this.$store.state.deleteIndent }, $style.wrapper]">
    <div @click="handleClick">
      <router-view></router-view>
      <Loading v-if="this.$store.state.loading" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import Loading from '@/components/Loading.vue';

export default defineComponent({
  components: { Loading },
  data() {
    return {
      previousScrollY: null,
    };
  },
  mounted() {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    if (isMobile && window.Telegram && window.Telegram.WebApp) {
      window.Telegram.WebApp.ready();
      window.Telegram.WebApp.expand();
      window.Telegram.WebApp.MainButton.hide();
      window.Telegram.WebApp.requestFullscreen();
    } else {
      this.$store.commit('deleteIndent', true);
    }
  },
  methods: {
    handleClick(event) {
      this.previousScrollY = window.scrollY;
      if (event.srcElement.localName === 'input' || event.srcElement.localName === 'textarea') {
        window.console.log('ok');
      } else {
        window.scrollTo(0, 0);
      }
    },
  },
});
</script>

<style lang="scss" module>
.wrapper {
  padding: 100px 0 0 0;
}
.deleteIndent {
  padding: 0;
}
</style>
